import React, { FC } from 'react';

import {
  PharmacyLegendVariant,
  ProfessionalReplacementTypes,
} from '@pharmaplan/common';
import { ReactComponent as TechnicianIcon } from '@pharmaplan/common/assets/icons/technicianIcon.svg';
import { ReactComponent as StudentIcon } from '@pharmaplan/common/assets/icons/studentIcon.svg';
import { ReactComponent as PharmacistIcon } from '@pharmaplan/common/assets/icons/pharmacistIcon.svg';

import { Grid } from '@mui/material';
import ThemeConstants from '../../../../theme/ThemeConstants';
import classes from './style';

const { bookedText, postedText, requestedText } = ThemeConstants.eventChip;
const { posted, requested, booked } = PharmacyLegendVariant;
const { pharmacist, student, technician } = ProfessionalReplacementTypes;

interface IProfessionalIconList {
  replacementTypes: Array<ProfessionalReplacementTypes>;
  type: PharmacyLegendVariant;
}

const ProfessionalIconList: FC<IProfessionalIconList> = ({
  replacementTypes,
  type,
}) => {
  const typeConfig = {
    [posted]: postedText,
    [requested]: requestedText,
    [booked]: bookedText,
  };

  const userConfig = {
    [pharmacist]: PharmacistIcon,
    [technician]: TechnicianIcon,
    [student]: StudentIcon,
  };

  return (
    <Grid sm={12} sx={classes.iconsList} item>
      {replacementTypes.map((item) => {
        const Icon = userConfig[item];

        return <Icon key={item} style={classes.icons} fill={typeConfig[type]} />;
      })}
    </Grid>
  );
};

export default ProfessionalIconList;
